export type BusinessSubCategory = {
  id?: number;
  name?: string;
  iconUrl?: string;
  active?: boolean;
  businessCategoryId?: number;
};
